import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { SiteFooter } from "@/components/site-footer";
import { PlanetMark } from "@/components/planet-mark";

export function LegalPage({
  title,
  eyebrow,
  lastUpdated,
  children,
}: {
  title: string;
  eyebrow?: string;
  lastUpdated?: string;
  children: React.ReactNode;
}) {
  return (
    <main className="mx-auto min-h-screen max-w-3xl px-6 pt-10">
      <div className="flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground">
          <ArrowLeft className="h-4 w-4" /> Back
        </Link>
        <Link to="/" className="flex items-center gap-2">
          <PlanetMark className="h-5 w-5" />
        <span className="text-sm font-semibold tracking-tight">Pyng</span>
        </Link>
      </div>
      <article className="prose prose-invert mt-12 max-w-none">
        {eyebrow && (
          <p className="text-[11px] uppercase tracking-[0.18em] text-accent-neon/80">{eyebrow}</p>
        )}
        <h1 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl">{title}</h1>
        {lastUpdated && <p className="mt-2 text-xs uppercase tracking-[0.18em] text-muted-foreground/70">Last updated {lastUpdated}</p>}
        <div className="mt-8 space-y-6 text-[15px] leading-relaxed text-foreground/90 [&_h2]:mt-10 [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:tracking-tight [&_h2]:text-foreground [&_p]:text-muted-foreground [&_li]:text-muted-foreground [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2 [&_ul]:marker:text-accent-neon/70 [&_a]:text-accent-neon [&_a:hover]:underline">
          {children}
        </div>
      </article>
      <SiteFooter />
    </main>
  );
}
